import Loading from '../Loading';

function CustomLoadingOverlay() {
  return <Loading delayed={false} />;
}

export default CustomLoadingOverlay;
